function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.49997 54.5C0.999971 53.5 -2.50003 44.5 3.99997 40L6.49997 32L13.5 19L55 20.5L63.5 40C68.5 44 67.5 51 60.5 54.5C43 74.5 18.5 67.5 6.49997 54.5Z",
  fill: "#FFB072"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5 43.5C41.5 41.5 42.9 37.5 48.5 37.5L48 48.5L41.5 48V43.5Z",
  fill: "#FAFEFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 42.5C14.5 40.8333 15.8 37.5 21 37.5L21.5 45L20.5 48.5C15.3 48.9 14.3333 44.6667 14.5 42.5Z",
  fill: "#FAFEFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5 42.5C53.0388 38.3494 50.0254 37.6017 47.9909 37.5107C44.997 41.0081 43.5046 45.0036 48 48.5H49C50.5 48.2364 54 47 53.5 42.5Z",
  fill: "#575B56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49 48.5C50.5 48.2364 54 47 53.5 42.5C53.0388 38.3494 50.0254 37.6017 47.9909 37.5107M49 48.5H41.5V44C41.5 39 45.5 37.5 47.5 37.5C47.6553 37.5 47.8196 37.503 47.9909 37.5107M49 48.5H48C43.5046 45.0036 44.997 41.0081 47.9909 37.5107M48 37.5C47.9969 37.5036 47.9939 37.5071 47.9909 37.5107",
  stroke: "#575B56",
  strokeWidth: 0.8
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5 48.5V43.5C26.5 40.7727 24.4338 38.0454 21.4285 37.5721C18.4844 40.5639 17.532 44.532 21.5 48.5H26.5Z",
  fill: "#575B56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5 48.5V43.5C26.5 40.7727 24.4338 38.0454 21.4285 37.5721M26.5 48.5H20M26.5 48.5H21.5M20 48.5C15 48.5 14 45 14.5 42C15 39 17 37.5 20.5 37.5C20.8181 37.5 21.128 37.5248 21.4285 37.5721M20 48.5H21.5M21.5 37.5C21.476 37.524 21.4522 37.548 21.4285 37.5721M21.5 48.5C17.532 44.532 18.4844 40.5639 21.4285 37.5721",
  stroke: "#575B56",
  strokeWidth: 0.8
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33 0.5L30 3.5C25.1666 3.16667 15.1 2.8 13.5 4C13.8333 4.83333 14.5 6.7 14.5 7.5C11 9 3.5 17.5 2.5 20.5L4.99998 19.5C3.33331 23.5 0.299982 32.5 1.49998 36.5L3.99996 34.5C3.83329 37.5 4.09996 44.1 6.49996 46.5V37.5C8.89996 35.1 10.8333 31.8333 11.5 30.5L13.5 33.5C15.1 31.9 18.1666 27.8333 19.5 26L27 32.5L34 25L41 32.5L48 26C49.6 29.6 53.6666 33.1667 55.5 34.5V30.5C58.3 35.7 61 37.3333 62 37.5V45.5L63 45L63.5 34.5L67 35.5C66.2 29.5 64 22.3333 63 19.5H64.5C62.9 15.9 56.1666 10 53 7.5V4C51 3.2 41.8333 3.33333 37.5 3.5L33 0.5Z",
  fill: "#474747",
  stroke: "#474747",
  strokeWidth: 0.25
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M51.5 16C50.3333 15.1667 47.8 13 47 11C48 11.8333 50.5 13.5 52.5 13.5L56 12.5C55.3333 13.6667 53.5 16 51.5 16Z",
  fill: "#2D2B26",
  stroke: "#2D2B26",
  strokeWidth: 0.25
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 16C14.1667 15.8333 11.4 14.9 11 12.5L15.5 13.5C16.3333 13.7034 18.4 13.6883 20 12C19.1667 13 17.1 15.2 15.5 16Z",
  fill: "#2D2B26",
  stroke: "#2D2B26",
  strokeWidth: 0.25
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23,
  cy: 44,
  rx: 1,
  ry: 2,
  fill: "#3E3F39"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 50,
  cy: 44,
  rx: 1,
  ry: 2,
  fill: "#3E3F39"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 34,
  cy: 49.5,
  rx: 3,
  ry: 2.5,
  fill: "#F47C42"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5 54.5C31 60 39 59 41.5 54.5",
  stroke: "#A5612F",
  strokeWidth: 0.8
});

var SvgGeorge = function SvgGeorge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGeorge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/george.ac5ab915.svg";
export { ForwardRef as ReactComponent };